import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './ListButtonsNew.css';
import UsaFlagIcon from '../../assets/images/flags/DELAWARE.svg';
import TurkeyFlagIcon from '../../assets/images/flags/TURKEY.svg';
import ChinaFlagIcon from '../../assets/images/flags/CHINA.svg';
import GreeceFlagIcon from '../../assets/images/flags/GREECE.svg';

const ListButtonsNew = ({ countryList, activeTab, setActiveTab, style }) => {
  const { t } = useTranslation();
  return (
    <div className='address-tab-items' style={style}>
      {countryList.map((item, index) => (
        <div key={index} onClick={() => setActiveTab(item)}>
          <div>
            <div>
              <div className={`address-tab-item ${activeTab === item && 'address-tab-item-active'}`}>
                <div className='address-tab-item-flag' style={{ textAlign: 'center' }}>
                  <img
                    style={{ width: 30 }}
                    src={item === 'DELAWARE' ? UsaFlagIcon : item === 'TURKEY' ? TurkeyFlagIcon : item === 'GREECE' ? GreeceFlagIcon : ChinaFlagIcon}
                    alt={t(`_${item}`)}
                  />
                  <p>{t(`_${item}`)}</p>
                </div>
                <p className='address-tab-item-title'>{t(`_${item}`)}</p>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ListButtonsNew;
